import { MEET_TY } from "@/lib/meet";

// /meet/ty — point expert confirmé. Présentationnel : la conversion
// (application_submitted) est déjà partie avant la redirection.
export function MeetThankYou({ firstName }: { firstName?: string }) {
  const prenom = firstName?.trim();
  return (
    <div className="mx-auto w-full max-w-xl text-center">
      <span className="mb-5 inline-flex items-center rounded-full border border-brand/30 bg-brand/10 px-3 py-1 text-xs font-medium text-brand">
        {MEET_TY.badge}
      </span>
      <h1 className="text-balance text-2xl font-extrabold sm:text-3xl">{MEET_TY.title}</h1>
      <p className="mx-auto mt-4 text-pretty text-ink/70">
        {prenom ? `${prenom}, ` : ""}
        {prenom ? MEET_TY.intro : MEET_TY.intro.charAt(0).toUpperCase() + MEET_TY.intro.slice(1)}
      </p>

      <div className="mt-8 rounded-2xl border border-ink/10 bg-white p-6 text-left">
        <p className="font-semibold text-ink">{MEET_TY.prepTitle}</p>
        <ol className="mt-4 space-y-4">
          {MEET_TY.prep.map(([title, detail], i) => (
            <li key={title} className="flex items-start gap-3">
              <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-gold text-sm font-bold text-ink">
                {i + 1}
              </span>
              <p className="text-sm text-ink/80">
                <span className="font-semibold text-ink">{title}</span> — {detail}
              </p>
            </li>
          ))}
        </ol>
      </div>

      <p className="mt-6 text-xs text-ink/45">{MEET_TY.outro}</p>
    </div>
  );
}
